import { useEffect, useState } from 'react';

import { BoostListItem } from '@components/boostListItem';
import { Button } from '@elements/button';
import { Text } from '@elements/text';
import { i18n } from '@i18n';
import { ROUTE_PATHS, router } from '@routes/router';
import { closeModalSelector, useModalStore, useTripStore } from '@store';
import { sendAnalyticsPage } from '@utils';

export function PersonalisationBoostModal() {
  const closeModal = useModalStore(closeModalSelector);
  const isLoading = useTripStore(state =>
    Object.values(state.boostApiState).some(i => i === 'pending'),
  );
  const [top3BoostCodes] = useState(
    useTripStore
      .getState()
      .trip?.boosts?.filter(b => !b?.isMandatory && b.code !== 'EMC')
      .slice(0, 3)
      ?.filter(b => !b.isAdded)
      .map(b => b.code),
  );

  const top3Boosts = useTripStore(
    state => state.trip?.boosts?.filter(boost => top3BoostCodes?.includes(boost.code)) ?? [],
  );

  useEffect(() => {
    sendAnalyticsPage('Personalisation upsell Modal Opened', {
      boostCodes: top3BoostCodes,
    });
  }, [top3BoostCodes]);

  return (
    <div>
      <div className="space-y-s8">
        <Text variant="h4-24/sb">
          {i18n.t(`personalisationBoost.title.${top3Boosts[0].code}` as any)}
        </Text>
        <Text variant="body-16/r" className="text-subtle">
          {i18n.t('personalisationBoost.description')}
        </Text>
      </div>
      <div className="my-s24">
        {top3Boosts?.map(boost => <BoostListItem key={boost.code} boost={boost} />)}
      </div>
      <Button
        variant="primary"
        isLoading={isLoading}
        title={i18n.t('personalisationBoost.action.title')}
        className="ml-auto"
        onClick={() => {
          closeModal();
          router.navigate(ROUTE_PATHS().checkout);
        }}
      />
    </div>
  );
}
